import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter as Router } from "react-router-dom"
import { Provider } from "react-redux"

import "./index.css"
import Routing from "./Routing"
import registerServiceWorker from "./registerServiceWorker"

import configureStore from "./configureStore"
import "./polyfills.js"
import objectFitImages from "object-fit-images"
import ReactGA from "react-ga"

const store = configureStore()

ReactGA.initialize("UA-15016925-4")
ReactGA.pageview(window.location.pathname + window.location.search)

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <Routing />
        </Router>
    </Provider>,
    document.getElementById("root")
)
registerServiceWorker()
objectFitImages()


// WEBPACK FOOTER //
// ./src/index.js